import React from 'react';
import iconSizes from 'constants/iconSizes.js';

const style = {
  display: 'inline-block',
  userSelect: 'none',
  flexShrink: 0,
};

const HeartThickIcon = ({ color = 'black', size = 'md', style: overrideStyles = {}, ...attr }) => {
  return (
    <svg style={{ ...style, ...overrideStyles }} viewBox="0 0 24 25" {...iconSizes[size]} fill="none" xmlns="http://www.w3.org/2000/svg" {...attr}>
      <path
        xmlns="http://www.w3.org/2000/svg"
        d="M12 20L11.8852 19.913C7.94709 16.9263 5.40571 14.5001 4.11592 12.4959C2.98792 10.7431 2.99505 9.57306 3.00085 8.63295C3.00126 8.56526 3.00167 8.49833 3.00167 8.43208C3.00167 7.40152 3.45666 6.29213 4.21877 5.46441C5.08827 4.52007 6.28691 4 7.59398 4C8.76963 4 9.93336 4.50773 10.9594 5.46831C11.4595 5.93651 11.8109 6.40097 12 6.67611C12.1891 6.40097 12.5405 5.93651 13.0406 5.46831C14.0666 4.50773 15.2303 4 16.406 4C17.713 4 18.9117 4.52007 19.7812 5.46441C20.5433 6.29213 20.9983 7.40152 20.9983 8.43208C20.9983 8.49833 20.9987 8.56523 20.9992 8.63295C21.002 9.10594 21.0053 9.64207 20.8661 10.2706C20.707 10.9883 20.3858 11.7162 19.884 12.4959C18.5942 14.5001 16.0529 16.9263 12.1148 19.913L12 20Z"
        strokeWidth={2}
        stroke={color}
      />
    </svg>
  );
};

export default HeartThickIcon;
